/**
 * MailTracker: Email tracker for Gmail
 *
 * Exposes a large fixed list of web-accessible resources — asset JS/CSS globs plus
 * dozens of vendor-named PNGs — to every origin with no use_dynamic_url. All are
 * reachable from any page at a stable URL.
 *
 * The mailtracker_icon.png is the cleanest signal: it loads through probeImage with no
 * CORS grant and its name is distinctive to this extension.
 *
 * Manifest verified against version 2.5.2.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'pgbdljpkijehgoacbjpolaomhkoffhnl';

export const mailtracker: ExtensionDefinition = {
  id: ID,
  name: 'MailTracker: Email tracker for Gmail',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Many static WAR on every origin, including vendor-named mailtracker_*.png images. ' +
    'Detection is a single load and conclusive.',
  signals: [
    {
      id: 'war-mailtracker-icon',
      kind: 'web-accessible-resource',
      description:
        'Load mailtracker_icon.png via <img> — a vendor-named icon exposed to every ' +
        'origin; needs no CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'mailtracker_icon.png'),
    },
    {
      id: 'war-pageworld-js',
      kind: 'web-accessible-resource',
      description: 'Fetch pageWorld.js — a main-world injected script exposed to every origin.',
      weight: 0.5,
      run: () => probeFetch(ID, 'pageWorld.js'),
    },
    {
      id: 'war-countries-json',
      kind: 'web-accessible-resource',
      description: 'Fetch countries.json — a bundled data file, a third independent path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'countries.json'),
    },
  ],
};
